import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import type { TodayScoutingRecord } from '../../services/activityService';
import { formatDateShort } from '../../dateFormat';

interface Props {
  items: TodayScoutingRecord[];
  loading: boolean;
}

export const RecentScoutingCard: React.FC<Props> = ({ items, loading }) => {
  const { t } = useTranslation();
  // Sort descending — most recent scouting first (past-only)
  const sorted = [...items].sort((a, b) => b.date.localeCompare(a.date));
  const visible = sorted.slice(0, 6);
  return (
    <section className="today-card">
      <header className="today-card__header">
        <h3 className="today-card__title">{t('home.recent.scouting.title')}</h3>
        <span className="today-card__count">{items.length}</span>
      </header>
      {loading && <div role="status" className="today-card__loading">{t('common.loading')}</div>}
      {!loading && items.length === 0 && (
        <div className="today-card__empty">{t('home.recent.scouting.empty')}</div>
      )}
      {!loading && visible.length > 0 && (
        <ul className="today-card__list">
          {visible.map(r => (
            <li key={r._id} className="today-card__item">
              <span className="today-card__primary">{r.blockId}</span>
              <span className="today-card__secondary">{(r.metadata && r.metadata.scouterName) || r.source}</span>
              <span className="today-card__date">{formatDateShort(r.date)}</span>
            </li>
          ))}
        </ul>
      )}
      {items.length > 0 && (
        <Link to="/scouting/review" className="today-card__view-all">
          {t('home.recent.scouting.viewAll')}
        </Link>
      )}
    </section>
  );
};

export default RecentScoutingCard;
